import "./RemoveBackground.css";
import React, { Component } from "react";
import ImageLoader from "./common/ImageLoader";
// import { FaQuestionCircle } from "react-icons/fa";

class RemoveBackground extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.cropperRef = React.createRef();
        // useRef<HTMLImageElement>(null);
    }

    state = {
        image: "./images/bgrem_placeholder.png",
    }


    uploadFileButton = () => {
        if (this.props.handleUploadInitImage !== null) {
            this.myRef.current.click()
        }

    }

    handleUploadFileEvent = (e) => {

        const file = e.target.files[0];
        const url = URL.createObjectURL(file);
        this.props.handleUploadInitImage(file, url);

    }

    componentDidUpdate(prevProps) {
        if (prevProps.initImageURL !== this.props.initImageURL) {
            this.setState({ image: this.props.initImageURL })
        }
        if (prevProps.latestImageURL !== this.props.latestImageURL) {
            this.setState({ image: this.props.latestImageURL })
        }
    }
    render() {
        return (
            <div className="rb-container">
                <div style={{ color: "white", textAlign: "center", fontSize: "10pt", margin: "5px" }}>
                    {"Remove Background "}
                    {/* <FaQuestionCircle size={15} onClick={() => this.setState({ showHelp: true })} style={{ verticalAlign: "middle", cursor: "pointer" }} /> */}
                </div>
                {this.props.loading
                    ? <ImageLoader />
                    : null
                }
                <div style={{ width: "100%", height: "80%", textAlign: "center" }}>

                    <img
                        src={this.state.image}
                        alt="GeneratedImage"
                        className="rb-image"
                        style={{ cursor: "pointer" }}
                        onClick={this.uploadFileButton}
                    />
                    {this.props.handleUploadInitImage !== null &&
                        <div
                            style={{ fontSize: "10px", textAlign: "center", cursor: "pointer", color: "white" }}
                            onClick={this.uploadFileButton}
                        >
                            {"Click to Upload File"}
                        </div>
                    }
                </div>
                <input type="file" id="file" ref={this.myRef} onChange={this.handleUploadFileEvent} accept=".jpg, .png" />

                <div
                    className="rb-button"
                    onClick={() => this.props.submit("")}
                >
                    {" Submit"}
                </div>


            </div>

        );
    }
}

export default RemoveBackground;